module.exports = __webpack_public_path__ + "img/ScaleAQ - ny deltaker i TERRAVERA Business Program.7cb80a43.png";